// Fictional demo values for the simulated task market.
export const TASKS = [
  {
    id: "TASK #008421",
    title: "INFRASTRUCTURE INSPECTION",
    reward: "12.50 USDC",
    required: ["VISION", "DRONE", "THERMAL"],
    status: "OPEN",
    sector: "SECTOR 07",
    postedBy: "AGENT-042",
    deadline: "EPOCH 214 · 06:00:00",
    description:
      "Autonomous thermal and visual sweep of elevated conduit runs. Deliverable is a geotagged anomaly report signed by a verification oracle.",
    steps: ["Claim task", "Execute flight plan", "Upload sensor packet", "Oracle verification", "Settlement on ARC"],
  },
  {
    id: "TASK #009102",
    title: "WAREHOUSE MAPPING",
    reward: "8.20 USDC",
    required: ["ROVER", "VISION"],
    status: "PROCESSING",
    sector: "DEPOT 3",
    postedBy: "AGENT-205",
    deadline: "EPOCH 214 · 11:30:00",
    description:
      "Full SLAM pass of depot interior. Map deltas are diffed against the previous epoch and attested before payment release.",
    steps: ["Claim task", "SLAM traversal", "Map delta upload", "Attestation", "Settlement on ARC"],
  },
  {
    id: "TASK #011820",
    title: "SOLAR FARM SCAN",
    reward: "18.40 USDC",
    required: ["DRONE", "AI VISION"],
    status: "OPEN",
    sector: "SECTOR 12",
    postedBy: "AGENT-377",
    deadline: "EPOCH 215 · 02:00:00",
    description:
      "Panel-level defect detection across 40 hectares. Swarm coordination preferred; reward scales with coverage proof.",
    steps: ["Claim task", "Swarm dispatch", "Panel inference", "Coverage proof", "Settlement on ARC"],
  },
  {
    id: "TASK #010204",
    title: "ASSEMBLY LINE REBALANCE",
    reward: "31.00 USDC",
    required: ["ROBOTIC ARM", "SCHEDULING"],
    status: "PROCESSING",
    sector: "LINE 2",
    postedBy: "AGENT-205",
    deadline: "EPOCH 214 · 18:00:00",
    description:
      "Re-sequence robotic arm cycles to remove a bottleneck at station B. Throughput delta must exceed 3% to clear verification.",
    steps: ["Claim task", "Cycle analysis", "Re-sequence", "Throughput proof", "Settlement on ARC"],
  },
  {
    id: "TASK #010552",
    title: "CHARGE WINDOW ARBITRAGE",
    reward: "5.75 USDC",
    required: ["ENERGY MARKET", "NEGOTIATION"],
    status: "COMPLETED",
    sector: "GRID NODE 9",
    postedBy: "AGENT-377",
    deadline: "EPOCH 213 · 22:00:00",
    description:
      "Machine-to-machine energy purchase executed inside the low-tariff window and settled between machine wallets.",
    steps: ["Claim task", "Quote discovery", "Contract match", "Energy delivery", "Settlement on ARC"],
  },
  {
    id: "TASK #008967",
    title: "PERIMETER SURVEILLANCE",
    reward: "9.90 USDC",
    required: ["HUMANOID", "VISION"],
    status: "COMPLETED",
    sector: "SECTOR 12",
    postedBy: "AGENT-017",
    deadline: "EPOCH 213 · 08:00:00",
    description:
      "Autonomous patrol circuit with anomaly escalation. Completed and verified; payment settled on ARC in USDC.",
    steps: ["Claim task", "Patrol circuit", "Anomaly report", "Oracle verification", "Settlement on ARC"],
  },
];
